import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DeceasedReport, ReportType } from '../../../../models/report.model';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit{

  public report!: DeceasedReport;
  public isLoading = true;

  constructor(
      private _reportService:ReportService,
      private _route:ActivatedRoute,
      private _router: Router
  ) {


  }


  ngOnInit() {
    this.isLoading = true;
    const reportId = this._route.snapshot.params['id'];
    console.log(reportId)
    if(!reportId){
      this.isLoading = false;
      return;
    }



    this._reportService.getReport(reportId).subscribe(
      data => {
        this.isLoading = false;
        let type:string = ''

        switch(data.data.type) {
          case ReportType.PRIMARY:
            type =  'podstawowy'
            break;
          case ReportType.EXTENDED:
            type =  'rozszerzony'
            break;
        }

        this._router.navigate(['/raport', type ,reportId], { replaceUrl: true})

      },  error => {
        this.isLoading = false;
      }
    )

  }
}
